var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDog309(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#f9f7e1;}.cls-2,.cls-3{stroke:#333;stroke-miterlimit:10;stroke-width:2px;}.cls-3{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_309"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_309",
    "data-name": 309,
    className: "cls-2",
    d: "M64.56,1.72c8.16,2.19,9,31.46,3.93,51.85-2.45,9.92-6.08,20-11.86,28.64a43.12,43.12,0,0,1-10.91,11.5c-1.39,1-10.58,6.8-15,3.56-2.35-1.71-2.42-5.25-2.45-8.42-.12-16.58,1.17-33.51,6.32-49.37a80.72,80.72,0,0,1,11-22.33C48.8,12.66,57.9-.07,64.56,1.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "detail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crevice",
    className: "cls-3",
    d: "M62,22.08a67.27,67.27,0,0,1-6.35,11.41,65,65,0,0,1-12,13.07,94.59,94.59,0,0,1,.82,14.17A95,95,0,0,1,42,80.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crevice-2",
    "data-name": "crevice",
    className: "cls-3",
    d: "M62,22.08a67.27,67.27,0,0,1-6.35,11.41,65,65,0,0,1-12,13.07,94.59,94.59,0,0,1,.82,14.17A95,95,0,0,1,42,80.48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog309);
export default __webpack_public_path__ + "static/media/dog_309.c842f1ae0259a234651b6ed4bc86481b.svg";
export { ForwardRef as ReactComponent };